import { Sandpack } from "@codesandbox/sandpack-react";

export default function Styling() {
  const code = `import { ReactUtilityTable } from 'react-utility-table';

export default function App() {
  const data = [
    { first_name: "John", last_name: "Cena", email: "JohnCena@gmail.com" },
    { first_name: "Randy", last_name: "Orton", email: "RandyOrton@gmail.com" },
    { first_name: "Roman", last_name: "Reign", email: "RomanReign@gmail.com" }
  ];

  const columns = [
    {
      title: "Name",
      field: "first_name",
      thStyle: { backgroundColor: "blue", color: "#fff" }
    },
    {
      title: "Last Name",
      field: "last_name"
    },
    {
      title: "Email",
      field: "email",
      cellStyle: (rowData) => ({
        backgroundColor: "rgb(241 187 33 / 55%)",
        color: rowData.first_name === "Randy" ? "red" : "green"
      })
    }
  ];

  const options = {
    headerStyle: {
      backgroundColor: "#5b2aef",
      color: "#FFF"
    },
    toolbarStyle: {
      backgroundColor: "#5b2aef",
      color: "#FFF"
    },
    globalSearch: false
  };

  return (
    <div>
      <ReactUtilityTable
        data={data}
        columns={columns}
        options={options}
      />
    </div>
  );
}
`;

  return (
    <div>
      <p style={{ margin: "5px 0px" }}>
        <strong>PlayGround for editable: </strong>
        <br />
        <br />
      </p>

      <Sandpack
        template="react"
        files={{ "/App.js": code }}
        customSetup={{
          dependencies: {
            react: "18.0.0",
            "react-dom": "18.0.0",
            "react-scripts": "5.0.1",
            "react-utility-table": "2.1.5"
          }
        }}
        theme="dark"
        options={{
          showLineNumbers: true,
          editorHeight: 500
        }}
      />
    </div>
  );
}

